export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q01_a.bbaf1891.png";